// extracted by mini-css-extract-plugin
export default {"colorBlock":"ColorBodyCell_colorBlock__uhAoQ"};